// =============================================================================
//  Copyright : 2018-2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : viewer package
// =============================================================================
import * as views from './views';
export { views };
export const parts = true;
export const jobs = true;
